export default "__VITE_ASSET__BjUCFmI___"